import React, { useState } from "react";
import loadable from "@loadable/component";
import { motion, AnimatePresence } from "framer-motion";
import { useIsMobile } from "../../hooks";

import { filterServicesStatic } from "../../static-data";
const LazyImg = loadable(() => import("../common/LazyImg"));
const FadeIn = loadable(() => import("../common/FadeIn"));

const FilterServices = () => {
  const isMobile = useIsMobile("1024");
  const { title, description, services, testimonial } = filterServicesStatic;
  return (
    <section className="p-filter-services">
      <div className="container">
        <div className="p-filter-services__header">
          {title && <h2 className="p-filter-services__title">{title}</h2>}
          {description && (
            <p className="p-filter-services__description">{description}</p>
          )}
        </div>
        <div className="p-filter-services__grid">
          {services.map((service, index) =>
            isMobile ? (
              <ServiceAccordion key={index} service={service} />
            ) : (
              <Service key={index} service={service} />
            )
          )}
        </div>
        <Quote testimonial={testimonial} />
      </div>
    </section>
  );
};

function Service({ service }) {
  const { svg, title, description, color } = service;
  return (
    <div
      className="p-filter-service"
      style={{ "--backgroundColor": color }}
    >
      <div className="p-filter-service__header">
        <FadeIn>
          <LazyImg className="p-filter-service__icon" alt={title} src={svg} />
        </FadeIn>
        <h3 className="p-filter-service__title">{title}</h3>
      </div>
      <div className="p-filter-service__description">{description}</div>
    </div>
  );
}
function ServiceAccordion({ service }) {
  const [isOpen, setIsOpen] = useState(false);
  const { svg, title, description, color } = service;

  return (
    <motion.div
      className={`p-filter-service ${isOpen ? "is-open" : ""}`}
      style={{ "--backgroundColor": color }}
    >
      <div className="p-filter-service__header">
        <FadeIn>
          <LazyImg className="p-filter-service__icon" alt={title} src={svg} />
        </FadeIn>
        <h3 className="p-filter-service__title">{title}</h3>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="p-filter-service__body"
          >
            <div className="p-filter-service__description">{description}</div>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        type="button"
        className="p-filter-service__accordion-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{isOpen ? "See less" : "See more"}</span>
      </button>
    </motion.div>
  );
}

function Quote({ testimonial }) {
  const { quote, name, label, image } = testimonial;
  return (
    <div className="p-filter-service__quote">
      <div className="p-filter-service__quote-content">
        {quote && (
          <blockquote className="p-filter-service__quote-text">
            {quote}
          </blockquote>
        )}

        {(image || name || label) && (
          <div className="p-filter-service__quote-author">
            {image && (
              <figure className="p-filter-service__quote-author-image">
                <img src={image} alt={name} />
              </figure>
            )}
            <p className="p-filter-service__quote-info">
              {name && (
                <span className="p-filter-service__author-name">{name}</span>
              )}
              {label && (
                <span className="p-filter-service__author-label">{label}</span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default FilterServices;
